module.exports = __webpack_public_path__ + "img/fire.20b4dddd.svg";